import React, { useState, useEffect } from "react";
import { findAllPocketBalanceEvent } from '../../../_events/pocket_balance/find_pocket_balance.event';
import { message } from "antd";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PrimaryProgress from "../../../containers/progress/primary_progress";
import { buildPriceFormat } from '../../../_utils/format_numbers';
import { DataGrid } from '@mui/x-data-grid';
import { withStyles } from "@mui/styles";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import { buildDateTimeStr } from '../../../_utils/date_operations';
const ID_PANEL = 'panel_pocket_balance';

const StyledDataGrid = withStyles({
    root: {
      "& .MuiDataGrid-renderingZone": {
        maxHeight: "none !important"
      },
      "& .MuiDataGrid-cell": {
        lineHeight: "unset !important",
        maxHeight: "none !important",
        whiteSpace: "normal"
      },
      "& .MuiDataGrid-row": {
        maxHeight: "none !important"
      }
    }
  })(DataGrid);


const PocketBalanceAccordion = (props) => {

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);

    /*
    const [expanded, setExpanded] = React.useState(false);
    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };
    */

    const columns = [
        { field: 'name', headerName: 'Cliente', width: 900, 
        valueGetter: (params) => params.row.name,
            renderCell: (params) => { 
                let d  = params.row; 
                return(
                    <div style={{width: '90%', paddingTop: '10px', paddingBottom: '10px'}}>
                        <Accordion key={`${ID_PANEL}${params.id}`} >
                        {/*<Accordion key={`${ID_PANEL}${key}`} expanded={expanded === `${ID_PANEL}${params.id}`} onChange={handleChange(`${ID_PANEL}${params.id}`)}> */}
                            <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls={`${ID_PANEL}${params.id}bh-content`}
                            id={`${ID_PANEL}${params.id}bh-header`}
                            >
                                <Typography sx={{ width: '60%', flexShrink: 0 }}>
                                    {d.name}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div style={{width: '100%'}}>
                                    <AccordionInfo data={d.pocketBalance} />
                                </div>
                            </AccordionDetails>
                        </Accordion>
                    </div>
                );
            }
        },
        { field: 'delay', headerName: 'Mora alta', width: 100,
        valueGetter: (params) => params.row.pocketBalance.sort((a, b) => b.delay - a.delay)[0].delay,
            renderCell: (params) => {
                return <span>{`${params.row.pocketBalance.sort((a, b) => b.delay - a.delay)[0].delay} días`}</span>;
            }
        },
        { field: 'total_value', headerName: 'Valor total', width: 100, 
        valueGetter: (params) => Number(getTotalValue(params.row)),
            renderCell: (params) => {
                return <span>{buildPriceFormat(getTotalValue(params.row))}</span>;
            }
        },
        { field: '', headerName: 'Ver', width: 100,
            renderCell: (params) => {
                return(<ModalInfo data={params.row.pocketBalance} />);
            }
        },
    ];

    const findData = () => {
        setLoading(true);
        findAllPocketBalanceEvent()
        .then(data => {
            let list = data.list.filter(d => d.pocketBalance.length > 0);
            setData(list);
            props.setLastUpdate(list.length > 0 ? buildDateTimeStr(list[list.length - 1].pocketBalance[list[list.length - 1].pocketBalance.length - 1].date_created) : 'Sin datos');
            setLoading(false);
        })
        .catch(err => {
            message.error(err.message);
            setLoading(false);
        });
    };

    const getTotalValue = (d) => {
        let total = 0;
        d.pocketBalance.map((v) => {
            total += Number(v.total_value);
            return total;
        });
        return total;
    }

    useEffect(() => {
        findData();
    }, []);   

    if(loading){
        return(
            <PrimaryProgress />
        );
    }
    else{
        return (
            <div style={{height: '500px', width: '100%'}}>
                <StyledDataGrid
                    rows={data}
                    columns={columns}
                    pageSize={100}
                    rowsPerPageOptions={[100]}
                    checkboxSelection={false}
                    getRowId={(p) => p.uuid}
                />
            </div>
        );
    }    
}

const AccordionInfo = (props) => {
    return(
        <>
        {
            props.data.length === 0 ? (
             <>No hay datos</>
            ) : (
            <div style={{width: '100%'}}>
                <div style={{width: '100%', display: 'flex', flexDirection: 'row'}}>
                    <div style={{width: '20%', fontSize:'10px', fontWeight: 'bold'}}>Número</div>
                    <div style={{width: '20%', fontSize:'10px', fontWeight: 'bold'}}>Fecha</div>                                
                    <div style={{width: '30%', fontSize:'10px', fontWeight: 'bold'}}>Valor</div>
                    <div style={{width: '20%', fontSize:'10px', fontWeight: 'bold'}}>Días Mora</div>
                </div>
                <div style={{width: '100%', overflowY: 'auto', height: '500px'}}>
                {
                    props.data.map((d, key) => {
                        let date = d.bill_date ? new Date(d.bill_date) : null;
                        let dateRep = date ? `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}` : 'NA';
                        return(
                            <div key={key} style={{width: '100%', display: 'flex', flexDirection: 'row'}}>
                                <div style={{width: '20%', fontSize:'10px'}}>{d.bill_number}</div>
                                <div style={{width: '20%', fontSize:'10px'}}>{dateRep}</div>
                                <div style={{width: '30%', fontSize:'10px'}}>{buildPriceFormat(Number(d.total_value))}</div>
                                <div style={{width: '20%', fontSize:'10px'}}>{d.delay}</div>
                            </div>
                        )
                    })
                }
                </div>
            </div>
            )
         }
        </>
    );
}

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

const ModalInfo = (props) => {

    const [open, setOpen] = React.useState(false);

    const handleOpen = () => {
        setOpen(true);     
    };

    const handleClose = () => {
        setOpen(false);
    };

    return(
        <div>
            <Button variant='contained' size='small' onClick={handleOpen}>Ver</Button>
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
            <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                <div style={{display: 'flex', flexDirection: 'column', width: '50%'}}>
                    <strong>
                        Cartera:
                    </strong>
                </div>                
                <div style={{display: 'flex', flexDirection: 'row-reverse', width: '50%'}}>
                    <Button size='small' onClick={handleClose}>Cerrar</Button>
                </div>
            </div>            
            {
               props.data.length === 0 ? (
                <>No hay reporte para este cliente</>
               ) : (
                <div style={{width: '100%'}}>
                    <div style={{width: '100%', display: 'flex', flexDirection: 'row'}}>
                        <div style={{width: '20%', fontSize:'10px', fontWeight: 'bold'}}>Número</div>
                        <div style={{width: '20%', fontSize:'10px', fontWeight: 'bold'}}>Fecha</div>                                
                        <div style={{width: '30%', fontSize:'10px', fontWeight: 'bold'}}>Valor</div>
                        <div style={{width: '20%', fontSize:'10px', fontWeight: 'bold'}}>Días Mora</div>
                    </div>
                    <div style={{width: '100%', overflowY: 'auto', height: '500px'}}>
                    {
                        props.data.map((d, key) => {
                            let date = d.bill_date ? new Date(d.bill_date) : null;
                            let dateRep = date ? `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}` : 'NA';
                            return(
                                <div key={key} style={{width: '100%', display: 'flex', flexDirection: 'row'}}>
                                    <div style={{width: '20%', fontSize:'10px'}}>{d.bill_number}</div>
                                    <div style={{width: '20%', fontSize:'10px'}}>{dateRep}</div>
                                    <div style={{width: '30%', fontSize:'10px'}}>{buildPriceFormat(Number(d.total_value))}</div>
                                    <div style={{width: '20%', fontSize:'10px'}}>{d.delay}</div>
                                </div>
                            )
                        })
                    }
                    </div>
                </div>
               )
            }
            </Box>
        </Modal>
        </div>
    );
}

export default PocketBalanceAccordion;